import React, { useState, useMemo } from 'react';

export const GridContextSelectionRow = React.createContext<{
  rowSelection: Record<string, boolean>;
  setRowSelection: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}>({ rowSelection: {}, setRowSelection: () => void 0 });

export const GridContextSelectionRowProvider = ({ children }: { children: React.ReactNode }) => {
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});
  const contextValue = useMemo(() => ({ rowSelection, setRowSelection }), [rowSelection, setRowSelection]);

  return <GridContextSelectionRow.Provider value={contextValue}>{children}</GridContextSelectionRow.Provider>;
};
